import React from "react";

function TabsPane({ className, id, style, children, ...restProps }) {
  return (
    <div className={"tab-panel " + className} style={style} name={id} {...restProps}>
      {children}
    </div>
  );
}

export default TabsPane;



// WEBPACK FOOTER //
// ./src/components/bewise/Tabs/TabsPane.js